import hyperdom from 'hyperdom'
import formats from '../../../../packages/dates/formats.js'
import formatDate from '../../../../packages/dates/formatDate.js'

export default function datesNotes (model) {

  const tourStartDate = model.departure.originDepartureDate ? model.departure.originDepartureDate : model.departure.startDate

  const parser = document.createElement('a')
  parser.href = model.config.brandPages.brandWebsite

  return <div class="flights__criteria-start-end-info message-info -strong u-margin-bottom-medium u-clearfix">
    <small className="flights__criteria-start-end-info__text u-margin-bottom-small">
        These dates are inclusive of any extra nights that you have chosen to book, before and after your trip.
    </small>
    <div class="flights__criteria-start-end-info-leg u-margin-top-small">
      { model.departure.originDepartureDate ?
        <div>
          <span class="o-form-item__label -compact">Departs</span>
          <div class="flights__criteria-start-end-info-start-date">{formatDate(tourStartDate.addDays(-1 * model.quoteCriteria.hotelsBefore.selectedNights.number), formats.human) }</div>
          <small>{`Board overnight flight to ${model.departure.startPlace.country}`}</small>
        </div>
        : <div>
          <span class="o-form-item__label -compact">Starts</span>
          <div class="flights__criteria-start-end-info-start-date">{formatDate(tourStartDate.addDays(-1 * model.quoteCriteria.hotelsBefore.selectedNights.number), formats.human) }</div>
          <small>{`${model.departure.startPlace.city}, ${model.departure.startPlace.country}`}</small>
        </div>
      }
    </div>
    <div class="flights__criteria-start-end-info-leg flights__criteria-start-end-info-end u-margin-top-small">
      <span class="o-form-item__label -compact">Ends</span>
      <div class="flights__criteria-start-end-info-end-date">{formatDate(model.departure.endDate.addDays(model.quoteCriteria.hotelsAfter.selectedNights.number), formats.human) }</div>
      <small>{`${model.departure.endPlace.city}, ${model.departure.endPlace.country}`}</small>
    </div>
  </div>
}



